/**
 * Ocorrência do cadastro.
 *
 * Espelha com.jkawflex.domain.empresa.CadCadastroOcorrencia (jkaw-domain).
 * O campo `avisar` é o enum CadastroOcorrenciaAvisar, serializado como objeto
 * ({ codigo, descricao }) pela API.
 */

export interface CadastroOcorrenciaAvisar {
  codigo: string;
  descricao: string;
}

export interface CadastroOcorrencia {
  id?: number;
  uuid?: string;
  /** data da ocorrência (yyyy-MM-dd) */
  dataOcorrencia?: string;
  /** descrição livre da ocorrência */
  ocorrencia?: string;
  /** início da validade do aviso (yyyy-MM-dd) */
  dataAvisarInicial?: string;
  /** fim da validade do aviso (yyyy-MM-dd) */
  dataAvisarFinal?: string;
  avisar?: CadastroOcorrenciaAvisar;
  status?: string;
  /** somente leitura: "id - doc - nomeFantasia" retornado pela API */
  cadastro?: string;
}

/**
 * Opções do enum CadastroOcorrenciaAvisar (mesma ordem/códigos do backend).
 */
export const AVISAR_OPTIONS: CadastroOcorrenciaAvisar[] = [
  { codigo: '1', descricao: '1 - Quando Entrar no Cadastro' },
  { codigo: '2', descricao: '2 - Quando Faturar' },
  { codigo: '3', descricao: '3 - Avisar Sempre' },
  { codigo: '9', descricao: '9 - Não Avisar' }
];
